import { useContext, useState } from "react";
import AppContext from "../../contexts/AppContext";
import { Alert, Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import apiFetch from "../../helperFunctions/api";
import useAsyncAction from "../../helperFunctions/useAsyncAction";
import { useParams } from "react-router-dom";

export default function StopSession() {
  let { API, session, setSession, navigate, setSessionOptions, getCharacters } =
    useContext(AppContext);

  const [open, setOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("")
  const [dialogDescription, setDialogDescription] = useState("");
  const { pending, error, run, clearError } = useAsyncAction();
  const { id } = useParams();




  const handleClickProcess = () => {
    clearError();
    setOpen(true);
    setDialogTitle("Process Session?")
    setDialogDescription("This will process the session and apply attedance DKP from the session.");
  }

  const handleClickCancel = () => {
    clearError();
    setOpen(true);
    setDialogTitle("Cancel Session?")
    setDialogDescription("This will delete the session and revert DKP for any gear added to this session.");
  }

  const handleClose = () => {
    if (!pending) setOpen(false);
  };

  const handleAgree = () => {
    run(async () => {
      const response = await apiFetch(`${API}/session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
        body: JSON.stringify({
          action: dialogTitle === "Cancel Session?" ? "CANCEL" : "CLOSE", sessionName: session, sessionId: id,
        }),
      });
      setSessionOptions(await response.json());
      getCharacters();
      setSession("");
      setOpen(false);
      navigate("/");
    });
  };

  return (
    <>
      <Button disabled={pending || !session} onClick={() => handleClickProcess()} variant="contained" color="success">
        Process Session
      </Button>

      <Button
        onClick={() => handleClickCancel()}
        color="error"
        variant="contained"
        disabled={pending || !session}
      >
        Cancel Session
      </Button>


      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogDescription}
          </DialogContentText>
          {error && <Alert severity="error">{error}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button disabled={pending} onClick={handleClose}>Disagree</Button>
          <Button disabled={pending} onClick={handleAgree} autoFocus>
            {pending ? "Saving..." : "Agree"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
